import { defineStore } from "pinia";

export const useUserStore = defineStore("user", {
  state: (): { user: any; isLoggedIn: boolean } => ({
    user: null,
    isLoggedIn: false,
  }),
  actions: {
    clearUser() {
      this.user = null;
      this.isLoggedIn = false;
    },
    setUser(user: any) {
      this.user = user;
      this.isLoggedIn = true;
    },
  },
});

